import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';

import {VirtualScrollerModule} from 'ngx-virtual-scroller';
import {BannerElementModule} from './banner/banner.module';
import {BannerComponent} from './banner.component';
import {IconsModule} from '../icons/icons.module';

import {SessionFormsModule} from '../../../shared/modules/session-forms/session-forms.module';


@NgModule({
  declarations: [BannerComponent],
  imports: [
    CommonModule,
    BannerElementModule,
    VirtualScrollerModule,
    IconsModule,
    SessionFormsModule
  ],
  exports: [BannerComponent],
})
export class BannerModule { }
